import { Component, ViewChild } from '@angular/core';
//import { FormConfig } from '../../../types/Forms';
//import { enumValues } from '../../../utils/enum-values';
import { HttpClient } from '@angular/common/http';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { Browser } from '@capacitor/browser';
import { IonInput, ModalController } from '@ionic/angular';
import { firstValueFrom, retry } from 'rxjs';
import { InformationModalPage } from 'src/app/pages/authentication/site-code-entry/information-modal/information-modal';
import { AnalyticsService } from 'src/app/services/analytics.service';
import { focusOnInput } from 'src/app/utils/focus-on-input';
import { Environment } from 'src/environments/environment';
import { AlertService } from '../../../services/alert.service';
import { AuthService } from '../../../services/auth.service';
import { LoadingService } from '../../../services/loading.service';
import { Gender, GENDERS } from '../../../types/Gender';
import { CLINICIAN, DISPLAY_DOB, HEALTH_CARE_PROVIDER } from '../../../utils/constants';
import { ValidationUtil, Validator } from '../../../utils/validation';
import { SiteModalPage } from './site-modal/site-modal';

export enum SiteCodeEntryFieldsPage {
  SITE = 'site',
}

export type SiteCodeItem = {
  SiteCode: string;
  tenant: string;
  name: string;
  language: string;
};


type SiteCodeEntryFormConfig = {
  [index in SiteCodeEntryFieldsPage]: [string, Validator[]] | FormControl
};

@Component({
  selector: 'app-site-code-entry',
  templateUrl: './site-code-entry.page.html',
  styleUrls: ['./site-code-entry.page.scss', '../authentication.scss'],
})
export class SiteCodeEntryPage {

  title = 'Register';
  siteEntryForm: FormGroup;

  @ViewChild('siteCodeInput', { static: true })
  siteCodeInput!: IonInput;

  isValid!: boolean;
  errorMessage!: string;
  normalizedPhoneNumber!: string;
  phone: any;
  dobDisplay: string = DISPLAY_DOB;
  healthCareProvider: string = HEALTH_CARE_PROVIDER;
  clinician: string = CLINICIAN;
  genders: Gender[] = GENDERS;

  constructor(
    private router: Router,
    public alertProvider: AlertService,
    private docTitle: Title,
    private formBuilder: FormBuilder,
    private modalCtrl: ModalController,
    private loadingProvider: LoadingService,
    private amplifyProvider: AuthService,
    private analyticsService: AnalyticsService,
    private http: HttpClient,
  ) {
    this.analyticsService.tagRoute('unauthenticated/siteCodeEntry');

    const formConfig: SiteCodeEntryFormConfig = {
      site: ['', [ValidationUtil.isRequired]]
    };

    this.docTitle.setTitle(this.title);
    this.siteEntryForm = this.formBuilder.group(formConfig);
  }

  ionViewDidEnter() {
    focusOnInput(this.siteCodeInput);
  }

  openProvidersPage() {
    Browser.open({ url: 'https://cardihab.com/find-a-provider/' });
  }

  async openInformationModal() {
    const modal = await this.modalCtrl.create({
      component: InformationModalPage,
    });
    await modal.present();
  }

  async submitForm() {
    this.loadingProvider.loadWhile(async (stopLoading) => {
      try {
        const formData = this.siteEntryForm.value;
        const siteCode = formData.site || '';
        const result = await firstValueFrom(this.http.get<SiteCodeItem>(`${Environment.SITES_URL}/site/${siteCode}`).pipe(retry(3)));
        if (result?.language) {
          this.router.navigate(['unauthenticated', 'consent'], { queryParams: { locale: result.language, siteCode } });
        } else {
          this.router.navigate(['unauthenticated', 'consent'], { queryParams: { siteCode } });
        }
      } catch (error) {
        this.handleError(error);
      } finally {
        stopLoading();
      }
    });
  }

  handleError(error: any) {
    if (error.status === 404) {
      this.siteEntryForm.markAsDirty();
      this.alertProvider.show(
        `Provider site not found`,
        `Please ask your ${this.healthCareProvider} or ${this.clinician} for this information.`
      );
    } else {
      this.alertProvider.show(
        'Connection Error',
        `We're having difficulties loading content. Please check your internet connection and try again.`,
      )
    }
  }

  async openSiteModal() {
    const modal = await this.modalCtrl.create({
      component: SiteModalPage,
    });
    await modal.present();
  }


  cancel() {
    if (this.siteEntryForm.dirty) {
      this.showDiscardConfirmation();
    } else {
      this.analyticsService.tagButtonPress('registration', 'cancel');
      this.router.navigate(['unauthenticated', 'home']);
    }
  }

  showDiscardConfirmation(): void {
    this.alertProvider.confirmDiscard(
      'Discard unsaved changes?',
      'Do you want to discard unsaved changes?',
      'Discard',
      () => {
        this.analyticsService.tagButtonPress('registration', 'cancel');
        this.router.navigate(['unauthenticated', 'home']);
      }
    );
  }

}
